export var separateNumbersAndText = function (inputString) {
    var numericParts = inputString.match(/[-+]?\d*\.?\d+/g) || [];
    var nonNumericParts = inputString.split(/[-+]?\d*\.?\d+/g);
    return {
        numericParts: numericParts,
        nonNumericParts: nonNumericParts,
        startWithNumber: inputString.search(numericParts[0]) === 0,
    };
};
export var removeEmptyItems = function (nonNumericParts) {
    return nonNumericParts.filter(function (part) { return part !== ""; });
};
export var joinNumbersAndText = function (numericParts, nonNumericParts, startWithNumber) {
    var result = "";
    for (var i = 0; i < Math.max(numericParts.length, nonNumericParts.length); i++) {
        if (!startWithNumber) {
            result += (nonNumericParts[i] || "") + (numericParts[i] || "");
        }
        else {
            result += (numericParts[i] || "") + (nonNumericParts[i] || "");
        }
    }
    return result;
};
